import styles from './SearchResultHeader.less';

import React, { Component, PropTypes } from 'react';

import FormattedMessage from 'FormattedMessage/FormattedMessage';

export default class SearchResultHeader extends Component {

  static propTypes = {
    message: PropTypes.object.isRequired
  };

  render() {
    const { message } = this.props;

    // Yes, this is somewhat arbitrary. We tried...
    const isNoResults = (message.parts[0].text === 'No results in ');

    return (
      <h1
        className={`${styles.root} ${isNoResults ? styles.noResults : ''}`}
        data-automation="searchResultHeader">
        <FormattedMessage message={message} />
      </h1>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SearchResultHeader/SearchResultHeader.js
 **/